<template lang="html">

    <section class="al-dia-home" v-if="!!getNoticias(position).length != 0 || !!getEventos(position).length != 0">

        <div class="container row-between">
            <h2 class="big-bold-title">Al día</h2>


            <div class="contenedor-noticias row-start ais" v-if="!!getNoticias(position)">
                <noticia :el="el" v-for="(el,key) in getNoticias(position).slice(0,3)" :key="key"></noticia>
            </div>


            <div class="contenedor-boton row-center">
                <router-link :to="$t('enlaces.aldia')+'?noticias'" class="btn -skull">Todas las noticias</router-link>
            </div>


            <div class="contenedor-eventos row-start ais" v-if="!!getEventos(position)">
                <evento :el="el" v-for="(el,key) in getEventos(position).slice(0,3)" :key="key"></evento>            
            </div>

            <div class="contenedor-boton row-center"  v-if="!!getEventos(position) && getEventos(position).length != 0">
                <router-link :to="$t('enlaces.aldia')+'?eventos'" class="btn -skull">Todos los eventos</router-link>
            </div>


        </div>

    </section>

</template>


<script lang="js">

    import {mapGetters} from 'vuex';
    import evento from '@/components/parts/evento-el';
    import noticia from '@/components/parts/noticia-el';
    export default {
        name: 'al-dia-banner',
        props : ['position'],
        computed:{
            ...mapGetters({
                getNoticias : 'getNoticias',
                getEventos : 'getEventos'
            }),
            noticia() {
                return this.getNoticias(this.position);
            },
            evento() {
                return this.getEventos(this.position);
            }
        },
        filters: {
            stringcategoria(value) {


                let cats = new Array();
                value.forEach(v => {
                    cats.push(v.nombre);
                })

                let last = cats.pop();
                if (value.length != 1) {
                    return cats.join(", ") + ' y ' + last;
                } else {
                    return last;
                }
            }
        },
         components: {
            'evento': evento,
            'noticia': noticia,
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/al-dia-banner.vue